import { cloudCall } from "./api";
import type { UserKit } from "./types";

export async function pullKit(token: string): Promise<UserKit | null> {
  try {
    const data = await cloudCall<{ kit: UserKit | null }>("/kit", { token });
    if (!data.kit) return null;
    return {
      hobbies: Array.isArray(data.kit.hobbies) ? data.kit.hobbies : [],
      gear: Array.isArray(data.kit.gear) ? data.kit.gear : [],
    };
  } catch {
    return null;
  }
}

export async function pushKit(token: string, kit: UserKit): Promise<boolean> {
  try {
    await cloudCall("/kit", {
      method: "PUT",
      token,
      body: JSON.stringify({
        hobbies: kit.hobbies || [],
        gear: kit.gear || [],
      }),
    });
    return true;
  } catch {
    return false;
  }
}

export type SavedPlan = {
  id?: string;
  title: string;
  detail?: string;
  minutes?: number | null;
  placeName?: string;
  map?: { lat: number; lon: number } | null;
  [key: string]: unknown;
};

export async function pullPlans(token: string): Promise<SavedPlan[] | null> {
  try {
    const data = await cloudCall<{ plans: SavedPlan[] }>("/plans", { token });
    return Array.isArray(data.plans) ? data.plans : [];
  } catch {
    return null;
  }
}

export async function pushPlan(token: string, plan: SavedPlan): Promise<boolean> {
  try {
    const { id: _id, map, ...rest } = plan;
    await cloudCall("/plans", {
      method: "POST",
      token,
      body: JSON.stringify({
        ...rest,
        title: plan.title,
        detail: plan.detail || "",
        minutes: plan.minutes ?? undefined,
        placeName: plan.placeName || "",
        lat: map?.lat,
        lon: map?.lon,
        map: map || null,
      }),
    });
    return true;
  } catch {
    return false;
  }
}

/** Tras login: kit (y planes) desde MySQL. */
export async function syncHermesFromCloud(
  getSession: () => Promise<{ id: string; token: string } | null>,
  setKit: (kit: UserKit) => Promise<void>,
): Promise<UserKit> {
  const session = await getSession();
  if (!session?.token) return { hobbies: [], gear: [] };
  const remote = await pullKit(session.token);
  const kit = remote || { hobbies: [], gear: [] };
  await setKit(kit);
  return kit;
}
